import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isLoggedIn().pipe(
    map(isLoggedIn => isLoggedIn || router.parseUrl('/login')),
    catchError(() => of(router.parseUrl('/login')))
  );
};
